import moment from 'moment';
import React from 'react';
import {getInputValue} from '../../utility';

const AppDatePicker = ({maxYear, onChangeDate, val, maxDate}) => {
  let formattedValue = '';

  if (val instanceof Date) {
    const parsedDate = moment(val);
    formattedValue = parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : '';
  } else if (typeof val === 'string') {
    const parsedDate = moment(val, moment.ISO_8601, true);
    formattedValue = parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : '';
  } else if (val) {
    const parsedDate = moment(val);
    formattedValue = parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : '';
  }

  return (
    <input
      className="form-control"
      type="date"
      value={formattedValue} // Ensure value is in 'YYYY-MM-DD' format
      id="date-input"
      onChange={valueOrEvent => {
        onChangeDate(getInputValue(valueOrEvent)); // Pass as a string
      }}
      max={maxYear ? moment().subtract(maxYear, 'Y').format('YYYY-MM-DD') : maxDate}
    />
  );
};

export default AppDatePicker;
